/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TranslateWarningDTO } from './translate-warning-dto';


export interface ConfigurazioneFormTranslateResponseDTO { 
    result?: any | null;
    warnings?: Array<TranslateWarningDTO>;
}

